import { render, staticRenderFns } from "./apiRecords.vue?vue&type=template&id=525cde8c&scoped=true&"
import script from "./apiRecords.vue?vue&type=script&lang=js&"
export * from "./apiRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525cde8c",
  null
  
)

export default component.exports